import { platformApi } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useIntelligenceItem(code) {
  const queryKey = ['intelligence', code];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      platformApi.get(`intelligence/${code}`, { signal }).json(),
    enabled: !!code && code !== 'new',
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
